/**
 * Application Configuration
 * Centralized configuration for the entire application
 */

const appConfig = {
  // Basic App Information
  NAME: "Turna",
  SITE_URL: "https://www.turna.com",
  ASSET_PREFIX_CDN_URL: "https://cdn.turna.com",
  DEFAULT_LANGUAGE: "tr",
  WEBSITE_VERSION: "saka", // Data layer eventlerinde ortak kullanılacak
  COUNTRY_CODE: "tr",

  // Third Party Services
  THIRD_PARTY_OPTIONS: {
    GOOGLE: {
      ANALYTICS: {
        ACTIVE: true,
        GTM_ID: "GTM-XXXXXXX", // Replace with actual GTM ID
      },
      RECAPTCHA_V3_CLIENT_KEY: "", // Add if needed
      MAP_API_KEY: "", // Add if needed
      SITE_VERIFICATION_CODE: "", // Add if needed
    },
  },

  // Responsive Breakpoints
  BREAKPOINTS: {
    MAX_MATCHES: "1024px",
    MIN_MATCHES: "1025px",
  },

  // Feature Flags
  FEATURES: {},

  // Product-specific configurations
  PRODUCT_CONFIGS: {
    BUS: {
      SHOW_PASSENGER_TYPE_BREAKDOWN: false, // true =yolcu seçimlerini göster, false = yolcu seçimini gizle
    },
    FERRY: {},
    FLIGHT: {},
  },
};

export default appConfig;
